import { ClockWorkModule } from "@/store/modules/clockWork.module";
import { toaster } from "@/utilities/toaster";
import { Machine } from "xstate";
const clockWorkSliderMachine = Machine({
    id: "clockWorkSlider",
    context: {
        isSavedSuccessful: false,
        deletedEntries: [],
    },
    initial: "idle",
    states: {
        idle: {
            tags: "isLoading",
            on: {
                GET_ENTRIES: { target: "entriesLoaded" },
            },
        },
        entriesLoaded: {
            initial: "idle",
            tags: "entriesLoaded",
            states: {
                idle: {
                    always: { target: "adjustEntry" },
                },
                adjustEntry: {
                    on: {
                        SPLIT_ENTRY: { target: "splitEntry" },
                        UPDATE_DESCRIPTION: { target: "updateDescription" },
                        SAVE_ENTRIES: { target: "savingEntries" },
                        STOP_ENTRY: { target: "stopEntry" },
                        DELETE_ENTRY: { target: "deleteEntry" },
                    },
                },
                splitEntry: {
                    tags: "splitEntry",
                    on: {
                        SPLITING_ENTRY: { target: "updateDescription" },
                        CANCEL: { target: "adjustEntry" },
                    },
                },
                deleteEntry: {
                    tags: "showRemoveUI",
                    on: {
                        DELETING_ENTRY: { target: "deletingEntry" },
                        CANCEL: { target: "adjustEntry" },
                    },
                },
                deletingEntry: {
                    tags: "showRemoveUI",
                    always: { target: "adjustEntry" },
                },
                updateDescription: {
                    on: {
                        ADJUST_ENTRIES: { target: "adjustEntry" },
                        UPDATING_DESCRIPTION: { target: "updatingDescription" },
                        SPLIT_ENTRY: { target: "splitEntry" },
                        SAVE_ENTRIES: { target: "savingEntries" },
                        STOP_ENTRY: { target: "stopEntry" },
                        DELETE_ENTRY: { target: "deleteEntry" },
                    },
                },
                updatingDescription: {
                    always: { target: "adjustEntry" },
                },
                savingEntries: {
                    tags: "savingEntries",
                    invoke: {
                        id: "searchingEntries",
                        src: (ctx, event) => {
                            return ClockWorkModule.AdjustMultipleEntries({ entries: event.entriesToUpdate, entryIdsToDelete: ctx.deletedEntries });
                        },
                        onDone: { target: "#clockWorkSlider.idle", actions: ["showSuccessMessage", "isSuccess"] },
                        onError: { target: "#clockWorkSlider.entriesLoaded" },
                    },
                },
                stopEntry: {
                    always: { target: "adjustEntry" },
                },
            },
        },
        serviceUnavailable: { type: "final" },
    },
}, {
    guards: {},
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        isSuccess: (context, event) => {
            context.isSavedSuccessful = true;
            return true;
        },
    },
});
export default clockWorkSliderMachine;
